"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntitySidebarDetailsLink = exports.EntitySidebarDetailsLinkDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_app_screen_1 = require("../../hooks/use-app-screen");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var sidebar_link_1 = require("../app/sidebar-link");
var icon_1 = require("../elements/icon");
var entity_icon_label_1 = require("./entity-icon-label");
var entity_bubble_image_1 = require("./entity-bubble-image");
exports.EntitySidebarDetailsLinkDefaultProps = {
  hasIcon: true
};
// -------- Styles -------->
var ActiveStyles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:hover {\n    color: ", ";\n    ", ";\n  }\n\n  ", "\n"], ["\n  &:hover {\n    color: ", ";\n    ", ";\n  }\n\n  ", "\n"])), theme_1.theme.COLOR('dark'), theme_1.theme.FILL('dark'), function (props) {
  return props.isActive && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    ", ";\n  "], ["\n    color: ", ";\n    ", ";\n  "])), theme_1.theme.COLOR('dark'), theme_1.theme.FILL('dark'));
});
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    ", "\n  "])), function (props) {
    return !props.hasIcon && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding-left: ", ";\n      padding-top: ", ";\n      padding-bottom: ", ";\n      margin-left: ", ";\n      border-left: 1px solid ", ";\n    "], ["\n      padding-left: ", ";\n      padding-top: ", ";\n      padding-bottom: ", ";\n      margin-left: ", ";\n      border-left: 1px solid ", ";\n    "])), theme_1.theme.UNIT(5, -2), theme_1.theme.UNIT(2.5), theme_1.theme.UNIT(2.5), theme_1.theme.UNIT(7, -1), theme_1.theme.COLOR('line-sidebar'));
  })
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    color: ", ";\n    ", ";\n    min-height: 18px;\n    line-height: 1.25em;\n    ", ";\n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    color: ", ";\n    ", ";\n    min-height: 18px;\n    line-height: 1.25em;\n    ", ";\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('primary'), theme_1.theme.FILL('primary'), ActiveStyles)
});
var ConnectionsLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n  "])), theme_1.theme.FILL('primary'), ActiveStyles)
});
var ConversationLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n  "])), theme_1.theme.FILL('primary'), ActiveStyles)
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(sidebar_link_1.SidebarLink)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: (0, styled_components_1.default)(entity_icon_label_1.EntityIconLabel)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Image: (0, styled_components_1.default)(entity_bubble_image_1.EntityBubbleImage)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  ConnectionsLink: (0, styled_components_1.default)(icon_1.Icon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ConnectionsLinkStyles),
  ConversationLink: (0, styled_components_1.default)(icon_1.Icon)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ConversationLinkStyles)
};
var EntitySidebarDetailsLink = function (props) {
  var className = props.className,
    entity = props.entity,
    hasIcon = props.hasIcon;
  var slug = entity && entity.slug;
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var to = definition.to(slug);
  var screen = (0, use_app_screen_1.useAppScreen)();
  var isActive = screen.slug === slug;
  return react_1.default.createElement(My.Container, {
    hasIcon: hasIcon,
    isActive: isActive,
    to: to,
    className: className
  }, react_1.default.createElement(My.Image, {
    entity: entity,
    size: 28
  }), react_1.default.createElement(My.Label, {
    hasIcon: hasIcon,
    isActive: isActive,
    entity: entity
  }, definition.sidebar.label(entity)));
};
exports.EntitySidebarDetailsLink = EntitySidebarDetailsLink;
exports.EntitySidebarDetailsLink.defaultProps = exports.EntitySidebarDetailsLinkDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;